import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { MDBTable, MDBTableHead, MDBTableBody, MDBBadge, MDBContainer, MDBIcon } from 'mdb-react-ui-kit';
import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { toast } from 'react-toastify';
import '../../index.css';
import Navbar from '../common/Navbar';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'; 
import apiService from '../../services/api.services';
import * as FileSaver from 'file-saver';
import * as ExcelJS from 'exceljs';

function CostSheetEntLogs() {
    const [allRows, setAllRows] = useState([]);
    const [appvStatus, setAppvStatus] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [filteredAppvStatusRows, setAppvStatusFilteredRows] = useState([]);
    const [searchKey, setSearchKey] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [excelData, setexcelData] = useState([]);
    const [error, setError] = useState(null);
    const rowsPerPage = 10;
    const navigate = useNavigate();

    const [mergedRows, setMergedRows] = useState([]); 
    
    useEffect(() => {
        const userID = window.sessionStorage.getItem('userId');
        const userRole = window.sessionStorage.getItem('role');
        const JWTtoken = window.sessionStorage.getItem('token');
    
        // Fetch both APIs in parallel
        Promise.all([
            apiService.getEntCostSheetLogs(JWTtoken, userID, userRole),
            apiService.getEntCostSheetApprovalRecords(JWTtoken)
        ]).then(([EntCostSheetLogResponse, EntCostSheetApprovalResponse]) => {

            const EntCostSheetLogData = EntCostSheetLogResponse.data;
            const approvalData = EntCostSheetApprovalResponse.data;
            console.log('EntCostSheetLogData>>', EntCostSheetLogData)
            console.log('approvalData>>>', approvalData)

            setFilteredRows(EntCostSheetLogData);
            // setFilteredRows([]);
            setAppvStatusFilteredRows(approvalData);
            const map = new Map();
            EntCostSheetLogData.forEach(item => {
                map.set(item.formSeries, { ...item });
            });
            approvalData.forEach(item => {
                if (map.has(item.formSeries)) {
                    map.set(item.formSeries, {
                        ...map.get(item.formSeries),
                        ...item // merge approval data
                    });
                }
            });
    
            const merged = Array.from(map.values());
            setMergedRows(merged);
            console.log('Merged Rows>>', merged)
            // console.log(":::: Merged Rows Based on formSeries ::::", merged);
        }).catch(error => {
            console.error('Error in fetching and merging:', error);
        });
    
        // Optionally fetch the excel export data
        apiService.getCostSheetLogExcelExport(JWTtoken, userID, userRole).then(response => {setexcelData(response.data);}).catch(error => {setError(error);});
    }, []);

    // Apply filters when searchKey or searchValue changes
    useEffect(() => {

          let filtered = [...mergedRows];

            // Search filter
            if (searchKey && searchValue) {
                filtered = filtered.filter((row) =>
                    row[searchKey]
                        ?.toString()
                        .toLowerCase()
                        .includes(searchValue.toLowerCase())
                );
            }

            // Status filter
            // if (selectedStatus.length > 0) {filtered = filtered.filter((row) =>selectedStatus.includes(row.status));}
            if (selectedStatus.length > 0) {
                if (selectedStatus.includes("Pending")) {
                    const userRole = window.sessionStorage.getItem("role");
                    const loginID = window.sessionStorage.getItem("userId");

                    filtered = filtered.filter((row) => {
                    switch (userRole) {
                        case "SALES":
                        case "OPERATIONS":
                        case "PURCHASE":
                            return ["Partial Approval", "Sent For Approval"].includes(row.status);

                        case "TEAM LEADER":
                            return row.approval?.appvTeamLeaderStatus === "Pending";

                        case "BRANCH HEAD":
                            return row.approval?.appvBranchHeadStatus === "Pending";

                        case "REGION BUSINESS HEAD":
                            return (
                                row.approval?.appvRegionBusinessHeadStatus === "Pending" ||
                                row.approval?.mgmtAppvRegionBusinessHeadStatus === "Pending"
                            );

                        case "BUSINESS FINANCE":
                            return (
                                row.approval?.appvBusinessFinanceStatus === "Pending" ||
                                row.approval?.mgmtAppvBusinessFinanceStatus === "Pending"
                            );

                        case "EXPORT COMPLIANCE":
                            return row.approval?.appvExportComplianceStatus === "Pending";

                        case "CREDIT INSURANCE":
                            return row.approval?.appvCreditInsuranceStatus === "Pending";

                        case "CEO":
                            return (
                                row.approval?.appvCEOStatus === "Pending" ||
                                row.approval?.mgmtAppvCEOStatus === "Pending"
                            );

                        case "COO":
                             return (
                                row.approval?.appvCOOStatus === "Pending" ||
                                row.approval?.mgmtAppvCOOStatus === "Pending"
                            );

                        case "CFO":
                             return (
                                row.approval?.appvCFOStatus === "Pending" ||
                                row.approval?.mgmtAppvCFOStatus === "Pending"
                            );

                        case "SVP-DIRECTOR":
                            return row.approval?.appvSVPDirectorStatus === "Pending";

                        case "LEGAL HEAD":
                            return row.approval?.appvLegalHeadStatus === "Pending";

                        case "DYT-CFO":
                            return row.approval?.appvDytCFOStatus === "Pending";

                        case "FUNCTIONAL HEAD":
                            return (
                                (loginID === row.approval?.appvFunctionalHeadID &&
                                row.approval?.appvFunctionalHeadStatus === "Pending") ||

                                (loginID === row.approval?.appvFunctionalHead2ID &&
                                row.approval?.appvFunctionalHead2Status === "Pending") ||

                                (loginID === row.approval?.appvFunctionalHead3ID &&
                                row.approval?.appvFunctionalHead3Status === "Pending") ||

                                (loginID === row.approval?.appvFunctionalHead4ID &&
                                row.approval?.appvFunctionalHead4Status === "Pending") ||

                                (loginID === row.approval?.appvFunctionalHead5ID &&
                                row.approval?.appvFunctionalHead5Status === "Pending") ||

                                (loginID === row.approval?.appvFunctionalHead6ID &&
                                row.approval?.appvFunctionalHead6Status === "Pending")
                            );

                            default:
                            return row.status === "Pending";
                        }
                        });
                    } else {
                        filtered = filtered.filter((row) => selectedStatus.includes(row.status));
                    }
            }

            setFilteredRows(filtered);
            setCurrentPage(1);

        // if (searchKey && searchValue) {
        //     const filtered = mergedRows.filter((row) =>
        //         row[searchKey]?.toString().toLowerCase().includes(searchValue.toLowerCase())
        //     );
        //     setFilteredRows(filtered);
        //     // setFilteredRows([]);
        //     setCurrentPage(1); // reset to first page when filtering
        // } else {
        //     setFilteredRows(mergedRows); // show all if filter is empty
        //     // setFilteredRows([]);
        // }
    }, [searchKey, searchValue, selectedStatus, mergedRows]);

    // Pagination calculations
    const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

    const pageGroupSize = 5;
    const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
    const startPage = currentGroup * pageGroupSize + 1;
    const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleAction = (formSeries) => {
        toast.success(`Open: ${formSeries}`);
        navigate(`/CostSheetEntForm/${formSeries}`);

        // const formseriesSent = formSeries;
        // const JWTtoken = window.sessionStorage.getItem('token');
        // apiService.getencparamAgainstSeries(JWTtoken, formseriesSent)
        // .then(
        //     response => {
        //        const encParam = String(response.data)
        //        toast.success(`Open: ${formSeries}`);
        //        navigate(`/CostSheetEntForm/Open/${encParam}`);
        //     })
        // .catch(
        //     error => {
        //         setError(error);
        //     });

        // const safeToken = jwt.sign({ formseriesSent }, secretKey);
        // const encParam = encodeURIComponent(safeToken);

        
        // navigate(`/CostSheetEntForm/${formSeries}`);
        // navigate(`/CostSheetEntForm/${formSeries}/${encParam}`);
    };

    const openNewForm = async () => {
        const userName = window.sessionStorage.getItem('userName');
        const userID = window.sessionStorage.getItem('userId');
        const userRole = window.sessionStorage.getItem('role');
        const JWTtoken = window.sessionStorage.getItem('token');

        // navigate(`/CostSheetEntForm/New`);

        await apiService.createCostSheetEntRecord(JWTtoken, userName, userID, userRole).then(response => {
            let series = response.data.series;
            const encParam = response.data.encParam
            toast.success(`Created: ${series}`);
            navigate(`/CostSheetEntForm/${series}`);
            // navigate(`/CostSheetEntForm/New/${encParam}`);
            
            console.log(':::::Success and New EntCostSheet Record Created:::::>', response.data.message);
        })
            .catch(error => {
                setError(error);
            });
    };

    const userName = window.sessionStorage.getItem('userName')
    const getCurrentFormattedDate = () => {
        const date = new Date();
        const day = date.getDate();
        const month = date.toLocaleString('en-US', { month: 'short' }); // e.g., "May"
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const exportExcel = () => {
        const userRole = window.sessionStorage.getItem('role');
        let header = [];
        let rowMapper = (row) => [];
    
        if (userRole === 'SALES' || userRole === 'OPERATIONS') {
          header = [
            "Form Series", "Status", "Customer Name", "SalesPerson Name", "CRM Number", "Approval Request Date", "OEM", "Opportunity Name",
            "Transaction Currency", "Secondary Transaction Currency", "Secondary Options", "Vendor Payment Terms", "Vendor Billing Cycle",
            "customerPaymentTerms", "dealType", "HitachiRoleInThisDeal", "materialDeliveryDate", "ReasonForMarginLessThanSixPercent",
            "Rebate Amount Details", "Conversion Rate", "Expected Date Customer Recipt", "Expected Date Vendor Payment", "Expert Advice Cashflow",
            "expert Advice Margin", "Functional Head 1 Name", "Functional Head 2 Name", "Functional Head 3 Name", "Functional Head 4 Name",
            "Functional Head 5 Name", "Functional Head 6 Name", "Send For Appv Req Date"
            ];
      
          rowMapper = (row) => [
            row.formSeries, row.approval.status, row.customerName, row.salesPersonName, row.crmNumber, row.approvalRequestDate, row.OEM, row.opportunityName, 
            row.transactionCurrency, row.secondaryTransactionCurrency, row.secondaryOptions, row.vendorPaymentTerms, row.vendorBillingCycle,
            row.customerPaymentTerms, row.dealType, row.HitachiRoleInThisDeal, row.materialDeliveryDate, row.ReasonForMarginLessThanSixPercent,
            row.RebateAmountDetails, row.ConversionRate, row.ExpectedDateCustomerRecipt, row.ExpectedDateVendorPayment, row.expertAdviceCashflow,
            row.expertAdviceMargin, row.functionalHead1Name, row.functionalHead2Name, row.functionalHead3Name, row.functionalHead4Name,
            row.functionalHead5Name, row.functionalHead6Name, row.sendForAppvReqDate
          ];
        } else if (userRole === 'TEAM LEADER' || userRole === 'BRANCH HEAD' || userRole === 'REGION BUSINESS HEAD' || userRole === 'BUSINESS FINANCE' || userRole === 'EXPORT COMPLIANCE'
             || userRole === 'CREDIT INSURANCE' || userRole === 'CFO' || userRole === 'CEO' || userRole === 'COO' || userRole === 'SVP-DIRECTOR'  || 
             userRole === 'LEGAL HEAD'|| userRole === 'DYT-CFO' || userRole === 'FUNCTIONAL HEAD' || userRole === 'ADMIN' ) {
          header = [
            "Form Series", "Status", "Customer Name", "SalesPerson Name", "CRM Number", "Approval Request Date", "OEM", "Opportunity Name",
            "Transaction Currency", "Secondary Transaction Currency", "Secondary Options", "Vendor Payment Terms", "Vendor Billing Cycle",
            "customerPaymentTerms", "dealType", "HitachiRoleInThisDeal", "materialDeliveryDate", "ReasonForMarginLessThanSixPercent",
            "Rebate Amount Details", "Conversion Rate", "Expected Date Customer Recipt", "Expected Date Vendor Payment", "Expert Advice Cashflow",
            "expert Advice Margin", "Send For Appv Req Date",
            "Team Leader Remarks", "Branch Head Remarks", "Regional Business Head Remarks", "Business Finance Remarks", "Export Compliance Remarks", 
            "Credit Insurance Remarks", "CFO Remarks", "CEO Remarks", "COO Remarks", "SVP-Director Remarks","Legal Head Remarks","DYT-CFO Remarks",
            "Functional Head-1 Remarks", "Functional Head-2 Remarks", "Functional Head-3 Remarks", "Functional Head-4 Remarks", "Functional Head-5 Remarks", "Functional Head-6 Remarks" 
          ];
      
          rowMapper = (row) => [
            row.formSeries, row.approval.status, row.customerName, row.salesPersonName, row.crmNumber, row.approvalRequestDate, row.OEM, row.opportunityName, 
            row.transactionCurrency, row.secondaryTransactionCurrency, row.secondaryOptions, row.vendorPaymentTerms, row.vendorBillingCycle,
            row.customerPaymentTerms, row.dealType, row.HitachiRoleInThisDeal, row.materialDeliveryDate, row.ReasonForMarginLessThanSixPercent,
            row.RebateAmountDetails, row.ConversionRate, row.ExpectedDateCustomerRecipt, row.ExpectedDateVendorPayment, row.expertAdviceCashflow,
            row.expertAdviceMargin,  row.sendForAppvReqDate,
            row.approval.appvTeamLeaderMessage, row.approval.appvBranchHeadMessage, row.approval.appvRegionBusinessHeadMessage, row.approval.appvBusinessFinanceMessage, row.approval.appvExportComplianceMessage, 
            row.approval.appvCreditInsuranceMessage, row.approval.appvCFOMessage, row.approval.appvCEOMessage, row.approval.appvCOOMessage, row.approval.appvSVPDirectorMessage,
            row.approval.appvFunctionalHeadMessage, row.approval.appvFunctionalHead2Message, row.approval.appvFunctionalHead3Message, row.approval.appvFunctionalHead4Message,
            row.approval.appvFunctionalHead5Message, row.approval.appvFunctionalHead6Message
          ];
        } else {
          alert("Export not allowed for this role.");
          return;
        }
      
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Data');
      
        worksheet.addRow(header);
      
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFF' } };
        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '808080' } };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
      
        // Add rows
        excelData.forEach(row => {
          worksheet.addRow(rowMapper(row));
        });
      
        // Adjust column widths
        header.forEach((column, index) => {
          const maxLength = Math.max(column.length, ...excelData.map(row => String(rowMapper(row)[index] || '').length));
          worksheet.getColumn(index + 1).width = maxLength + 2;
        });
      
        // Apply borders
        for (let row = 1; row <= worksheet.rowCount; row++) {
          for (let col = 1; col <= header.length; col++) {
            const cell = worksheet.getCell(row, col);
            cell.border = {
              top: { style: 'thin', color: { argb: '000000' } },
              left: { style: 'thin', color: { argb: '000000' } },
              bottom: { style: 'thin', color: { argb: '000000' } },
              right: { style: 'thin', color: { argb: '000000' } }
            };
          }
        }
      
        // Save file
        workbook.xlsx.writeBuffer().then(buffer => {
          const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          FileSaver.saveAs(data, `${userName}_EntCostSheet_${getCurrentFormattedDate()}.xlsx`);
        });
      };

    if (error) return <h1>Error: {error.message}</h1>;

  return (
     <>
                 <Navbar />
                 <h4 className='headerRibbon'>Enterprise Costsheet Logs</h4>
     
              <style>
             {`
               /* TR styling */
               .expandable-row {
                 transition: background-color 0.3s ease;
               }
     
               .expandable-row:hover {
                 background-color: #f9f9f9;
               }
     
               /* TD styling */
               .expandable-cell {
                 padding: 0;
                 margin: 0;
                 border: none;
               }
     
               /* Inner wrapper for animation */
               .cell-wrapper {
                 max-height: 30px;
                 overflow: hidden;
                 transition: max-height 0.4s ease;
                 padding: 10px;
               }
     
               .expandable-row:hover .cell-wrapper {
                 max-height: 500px;
               }
             `}
           </style>
     
                 <MDBContainer className="pt-5 pb-4">
                     <Row className="justify-content-between" md="12" style={{ display: "flex", border: "3px solid lightgrey", borderRadius: "20px" }}>
                        <Col md="4">
                             <div style={{ padding: '20px' }}>
                                 {/* Search Section */}
                                 <Form className="d-flex gap-3">
                                     <Form.Group controlId="searchKey">
                                         {/* <Form.Label>Search Field</Form.Label> */}
                                         <Form.Control
                                             as="select"
                                             value={searchKey}
                                             onChange={(e) => setSearchKey(e.target.value)}
                                         >
                                             <option value="">-- Select Field --</option>
                                             <option value="formSeries">Form Series</option>
                                             <option value="crmNumber">CRM Number</option>
                                             <option value="status">Final Status</option>
                                             <option value="salesPersonName">Sales Person</option>
                                             <option value="customerName">Customer Name</option>
                                             {/* <option value="userId">Created By</option> */}
                                             {/* Add more keys as needed */}
                                         </Form.Control>
                                     </Form.Group>
     
                                     <Form.Group controlId="searchValue">
                                         {/* <Form.Label>Search Value</Form.Label> */}
                                         <Form.Control
                                             type="text"
                                             placeholder="Enter search value"
                                             value={searchValue}
                                             onChange={(e) => setSearchValue(e.target.value)}
                                         />
                                     </Form.Group>
                                 </Form>
                             </div>
                         </Col>
                         <Col md="2">
                            <div style={{ padding: '20px' }}>
                                <Button variant="warning"  onClick={() => setSelectedStatus(["Pending"])}>Pending <MDBIcon fas icon="clock" size="lg" /><br />
                                    {/* <strong>10</strong> */}
                                    </Button>
                            </div>
                        </Col>
                         {(sessionStorage.getItem('role') === 'SALES' || sessionStorage.getItem('role') === 'TEAM LEADER' || sessionStorage.getItem('role') === 'ADMIN') && (
                             <Col md="2">
                                 <div style={{ padding: '20px' }}>
                                     <Button variant="success" onClick={openNewForm}>New +</Button>
                                 </div>
                             </Col>
                         )}
                         <Col md="2">
                             <div style={{ padding: '20px' }}>
                                 <Button variant="outline-secondary" onClick={exportExcel}>EXPORT  <MDBIcon fas icon="fas fa-download" size='lg' /></Button>
                             </div>
                         </Col>
                     </Row>
                     <Row className="justify-content-between" md="12" style={{ display: "flex" }}>
                        <Col md="2">
                            <div style={{ padding: '10px' }}>
                                <Button variant="outline-info" onClick={() => setSelectedStatus("")}>Total <MDBIcon fas icon="clipboard-list" size="lg" /><br />
                                    {/* <strong>20</strong> */}
                                    </Button>
                            </div>
                        </Col>
                        {(sessionStorage.getItem('role') === 'SALES') && (
                            <Col md="2">
                                <div style={{ padding: '10px' }}>
                                    <Button variant="outline-secondary" onClick={() => setSelectedStatus("Open")}>Open <MDBIcon fas icon="pencil" size="lg" /><br />
                                        {/* <strong>50</strong> */}
                                    </Button>
                                </div>
                            </Col>
                        )}
                        <Col md="2">
                            <div style={{ padding: '10px' }}>
                                <Button variant="outline-success" onClick={() => setSelectedStatus("Approved")}>Final Approved <MDBIcon fas icon="check-circle" size="lg" /><br />
                                    {/* <strong>100</strong> */}
                                    </Button>
                            </div>
                        </Col>
                        <Col md="2">
                            <div style={{ padding: '10px' }}>
                                <Button variant="outline-danger" onClick={() => setSelectedStatus("Rejected")}>Final Rejected <MDBIcon fas icon="times-circle" size="lg" /><br />
                                    {/* <strong>5</strong> */}
                                    </Button>
                            </div>
                        </Col>
                        {/* <Col md="2">
                            <div style={{ padding: '10px' }}>
                                <Button variant="outline-info" onClick={() => setSelectedStatus("PO Received")}>PO Received <MDBIcon fas icon="file" size="lg" /><br />
                                    <strong>20</strong>
                                    </Button>
                            </div>
                        </Col> */}
                     </Row>
                 </MDBContainer>
                 <MDBContainer fluid style={{ justifyItems: 'center' }}>
                     {/* <MDBContainer fluid className='vh-90' style={{ backgroundColor: "#E0E0E0" }}> */}
                     <div style={styles.tableWrapper}>
                         <MDBTable align='middle' bordered hover>
                             <MDBTableHead className='table-dark sticky-header'>
                                 <tr>
                                     {/* <th scope='col' ></th> */}
                                     <th scope='col' >Form Id</th>
                                     <th scope='col' >CRM Number</th>
                                     <th scope='col' >Customer Name</th>
                                     <th scope='col' >Saleperson Id</th>
                                     <th scope='col' >Salesperson Name</th>
                                     <th scope='col' >Opportunity Name</th>
                                     <th scope='col' >Opportunity Category</th>
                                     {/* <th scope='col' >Selling Value</th> */}
                                     <th scope='col' >Created ID</th>
                                     <th scope='col' >Creation Date</th>
                                     <th scope='col' >Team Leader Status</th>
                                     <th scope='col' >Branch Head Status</th>
                                     <th scope='col' >Region Business Head Status</th>
                                     <th scope='col' >Functional Head Status</th>
                                     <th scope='col' >Business Finance Status</th>
                                     <th scope='col' >Export Compliance Status</th>
                                     <th scope='col' >Credit Insurance Status</th>
                                     <th scope='col' >CEO Status</th>
                                     <th scope='col' >COO Status</th>
                                     <th scope='col' >CFO Status</th>
                                     <th scope='col' >SVP Director Status</th>
                                     <th scope='col' >DYT CFO Status</th>
                                     <th scope='col' >Legal Head Status</th>
                                     <th scope='col' >Final Status</th>
     
                                 </tr>
                             </MDBTableHead>
                             <MDBTableBody>
                                 {/* {currentRows */}
                                 {[...currentRows]
                                 .sort((a, b) => a.id - b.id)
                                 .map((row, index) => (
                                     <tr key={index} onDoubleClick={() => handleAction(row.formSeries)} className="expandable-row" >
                                         {/* <th scope='row'></th> */}
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0 cell-wrapper'>{row.formSeries}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0 cell-wrapper'>{row.crmNumber}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0 cell-wrapper'>{row.customerName}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.salesPersonID}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.salesPersonName}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.opportunityName}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.OEM}</p>
                                         </td>
                                         {/* <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.sellingValueTotal}</p>
                                         </td> */}
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.userId}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             <p className='text-muted mb-0  cell-wrapper'>{row.recordCreatedAt}</p>
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvTeamLeaderStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvTeamLeaderMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvTeamLeaderStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvTeamLeaderStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvBranchHeadStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvBranchHeadMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvBranchHeadStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvBranchHeadStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvRegionBusinessHeadMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvRegionBusinessHeadStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvFunctionalHeadMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvFunctionalHeadStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvBusinessFinanceStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvBusinessFinanceMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvBusinessFinanceStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvBusinessFinanceStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvExportComplianceStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvExportComplianceMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvExportComplianceStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvExportComplianceStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvCreditInsuranceStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCreditInsuranceMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCreditInsuranceStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvCreditInsuranceStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvCEOStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCEOMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCEOStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvCEOStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvCOOStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCOOMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCOOStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvCOOStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvCFOStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCFOMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCFOStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvCFOStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvSVPDirectorStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvSVPDirectorMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvSVPDirectorStatus} </p>
                                                 </OverlayTrigger>
                                             {/* ) : (
                                                 <p className='text-muted mb-0  cell-wrapper'>{row.appvSVPDirectorStatus}</p>
                                             )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvDytCFOMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvDytCFOStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                             {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
                                                 <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvLegalHeadMessage || 'No message'} </Tooltip>}>
                                                     <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvLegalHeadStatus} </p>
                                                 </OverlayTrigger>
                                             {/* // ) : (
                                             //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
                                             // )} */}
                                         </td>
                                         <td className="expandable-cell">
                                         <MDBBadge 
                                             color={
                                                     row.approval.status === 'Open' ? 'primary' :
                                                     row.approval.status === 'Sent for Approval' ? 'warning' :
                                                     row.approval.status === 'Partial Approval' ? 'success' :
                                                     row.approval.status === 'Approved' ? 'success' :
                                                     row.approval.status === 'PO Received' ? 'success' :
                                                     row.approval.status === 'Rejected' ? 'danger' :
                                                     row.approval.status === 'Partial Rejected' ? 'danger' :
                                                     row.approval.status === 'Closed' ? 'secondary' :
                                                     null
                                                 }pill> {row.approval.status}
                                         </MDBBadge>
                                         </td>
                                     </tr>
                                 ))}
                             </MDBTableBody>
                         </MDBTable>
                     </div>
     
                     {/* Pagination Controls */}
                     {/* <div style={styles.pagination}>
                         <button
                             style={styles.pageButton}
                             disabled={currentPage === 1}
                             onClick={() => handlePageChange(currentPage - 1)}
                         >
                             Previous
                         </button>
                         {[...Array(totalPages).keys()].map((number) => (
                             <button
                                 key={number}
                                 style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
                                 onClick={() => handlePageChange(number + 1)}
                             >
                                 {number + 1}
                             </button>
                         ))}
                         <button
                             style={styles.pageButton}
                             disabled={currentPage === totalPages}
                             onClick={() => handlePageChange(currentPage + 1)}
                         >
                             Next
                         </button>
                     </div> */}
     
                      <div style={styles.pagination}>
                 <button
                     style={styles.pageButton}
                     disabled={currentPage === 1}
                     onClick={() => handlePageChange(currentPage - 1)}
                 >
                     Previous
                 </button>
     
                 {startPage > 1 && (
                     <>
                         <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
                         <span style={styles.ellipsis}>...</span>
                     </>
                 )}
     
                 {[...Array(endPage - startPage + 1).keys()].map((index) => {
                     const pageNum = startPage + index;
                     return (
                         <button
                             key={pageNum}
                             style={{
                                 ...styles.pageButton,
                                 ...(pageNum === currentPage ? styles.activePageButton : {}),
                             }}
                             onClick={() => handlePageChange(pageNum)}
                         >
                             {pageNum}
                         </button>
                     );
                 })}
     
                 {endPage < totalPages && (
                     <>
                         <span style={styles.ellipsis}>...</span>
                         <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                     </>
                 )}
     
                 <button
                     style={styles.pageButton}
                     disabled={currentPage === totalPages}
                     onClick={() => handlePageChange(currentPage + 1)}
                 >
                     Next
                 </button>
             </div>
     
                 </MDBContainer>
             </>
  )
}

// Inline CSS for the component
const styles = {
        tableWrapper: {
            maxWidth: '95%',
            overflowX: 'auto', // Enable horizontal scrolling
            overflowY: 'auto', // Enable vertical scrolling
            maxHeight: '450px', // Adjust the height to fit your needs
            marginBottom: '10px',
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            gap: '5px',
            flexWrap: 'wrap',
            marginTop: '1rem',
        },
        pageButton: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '5px 10px',
            cursor: 'pointer',
            outline: 'none',
        },
        activePageButton: {
            backgroundColor: '#0056b3',
        },
        ellipsis: {
            padding: '5px 10px',
            color: '#555',
        },
            
    };

// CSS styles
const stickyHeaderStyles = `
.sticky-header th {
    position: sticky;
    top: 0;
    z-index: 10; // Ensures the header is on top
    background-color: #343a40; // Match the table header color
    color: white; // Text color for header
}
`;

// Add the sticky header styles to the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = stickyHeaderStyles;
document.head.appendChild(styleSheet);

export default CostSheetEntLogs










// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'
// import { MDBTable, MDBTableHead, MDBTableBody, MDBBadge, MDBContainer, MDBIcon } from 'mdb-react-ui-kit';
// import { Form, Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import { toast } from 'react-toastify';
// import '../../index.css';
// import Navbar from '../common/Navbar';
// import 'mdb-react-ui-kit/dist/css/mdb.min.css'; 
// import apiService from '../../services/api.services';
// import * as FileSaver from 'file-saver';
// import * as ExcelJS from 'exceljs';

// function CostSheetEntLogs() {
//     const [allRows, setAllRows] = useState([]);
//     const [appvStatus, setAppvStatus] = useState([]);
//     const [filteredRows, setFilteredRows] = useState([]);
//     const [filteredAppvStatusRows, setAppvStatusFilteredRows] = useState([]);
//     const [searchKey, setSearchKey] = useState('');
//     const [searchValue, setSearchValue] = useState('');
//     const [currentPage, setCurrentPage] = useState(1);
//     const [excelData, setexcelData] = useState([]);
//     const [error, setError] = useState(null);
//     const rowsPerPage = 10;
//     const navigate = useNavigate();

//     const [mergedRows, setMergedRows] = useState([]); 
    
//     useEffect(() => {
//         const userID = window.sessionStorage.getItem('userId');
//         const userRole = window.sessionStorage.getItem('role');
//         const JWTtoken = window.sessionStorage.getItem('token');
    
//         // Fetch both APIs in parallel
//         Promise.all([
//             apiService.getEntCostSheetLogs(JWTtoken, userID, userRole),
//             apiService.getEntCostSheetApprovalRecords(JWTtoken)
//         ]).then(([EntCostSheetLogResponse, EntCostSheetApprovalResponse]) => {

//             const EntCostSheetLogData = EntCostSheetLogResponse.data;
//             const approvalData = EntCostSheetApprovalResponse.data;
//             console.log('EntCostSheetLogData>>', EntCostSheetLogData)
//             console.log('approvalData>>>', approvalData)

//             setFilteredRows(EntCostSheetLogData);
//             setAppvStatusFilteredRows(approvalData);
//             const map = new Map();
//             EntCostSheetLogData.forEach(item => {
//                 map.set(item.formSeries, { ...item });
//             });
//             approvalData.forEach(item => {
//                 if (map.has(item.formSeries)) {
//                     map.set(item.formSeries, {
//                         ...map.get(item.formSeries),
//                         ...item // merge approval data
//                     });
//                 }
//             });
    
//             const merged = Array.from(map.values());
//             setMergedRows(merged);
//             console.log('Merged Rows>>', merged)
//             // console.log(":::: Merged Rows Based on formSeries ::::", merged);
//         }).catch(error => {
//             console.error('Error in fetching and merging:', error);
//         });
    
//         // Optionally fetch the excel export data
//         apiService.getCostSheetLogExcelExport(JWTtoken, userID, userRole).then(response => {setexcelData(response.data);}).catch(error => {setError(error);});
//     }, []);

//     // Apply filters when searchKey or searchValue changes
//     useEffect(() => {
//         if (searchKey && searchValue) {
//             const filtered = mergedRows.filter((row) =>
//                 row[searchKey]?.toString().toLowerCase().includes(searchValue.toLowerCase())
//             );
//             setFilteredRows(filtered);
//             setCurrentPage(1); // reset to first page when filtering
//         } else {
//             setFilteredRows(mergedRows); // show all if filter is empty
//         }
//     }, [searchKey, searchValue, mergedRows]);

//     // Pagination calculations
//     const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
//     const indexOfLastRow = currentPage * rowsPerPage;
//     const indexOfFirstRow = indexOfLastRow - rowsPerPage;
//     const currentRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

//     const pageGroupSize = 5;
//     const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
//     const startPage = currentGroup * pageGroupSize + 1;
//     const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     const handleAction = (formSeries) => {
//         toast.success(`Open: ${formSeries}`);
//         navigate(`/CostSheetEntForm/${formSeries}`);
//     };

//     const openNewForm = async () => {
//         const userName = window.sessionStorage.getItem('userName');
//         const userID = window.sessionStorage.getItem('userId');
//         const userRole = window.sessionStorage.getItem('role');
//         const JWTtoken = window.sessionStorage.getItem('token');

//         // navigate(`/CostSheetEntForm/New`);

//         await apiService.createCostSheetEntRecord(JWTtoken, userName, userID, userRole).then(response => {
//             let series = response.data.series;
//             navigate(`/CostSheetEntForm/${series}`);
//             console.log(':::::Success and New EntCostSheet Record Created:::::>', response.data.message);
//         })
//             .catch(error => {
//                 setError(error);
//             });
//     };

//     const userName = window.sessionStorage.getItem('userName')
//     const getCurrentFormattedDate = () => {
//         const date = new Date();
//         const day = date.getDate();
//         const month = date.toLocaleString('en-US', { month: 'short' }); // e.g., "May"
//         const year = date.getFullYear();

//         return `${day}-${month}-${year}`;
//     };

//     const exportExcel = () => {
//         const userRole = window.sessionStorage.getItem('role');
//         let header = [];
//         let rowMapper = (row) => [];
    
//         if (userRole === 'SALES' || userRole === 'OPERATIONS') {
//           header = [
//             "Form Series", "Status", "Customer Name", "SalesPerson Name", "CRM Number", "Approval Request Date", "OEM", "Opportunity Name",
//             "Transaction Currency", "Secondary Transaction Currency", "Secondary Options", "Vendor Payment Terms", "Vendor Billing Cycle",
//             "customerPaymentTerms", "dealType", "HitachiRoleInThisDeal", "materialDeliveryDate", "ReasonForMarginLessThanSixPercent",
//             "Rebate Amount Details", "Conversion Rate", "Expected Date Customer Recipt", "Expected Date Vendor Payment", "Expert Advice Cashflow",
//             "expert Advice Margin", "Functional Head 1 Name", "Functional Head 2 Name", "Functional Head 3 Name", "Functional Head 4 Name",
//             "Functional Head 5 Name", "Functional Head 6 Name", "Send For Appv Req Date"
//             ];
      
//           rowMapper = (row) => [
//             row.formSeries, row.status, row.customerName, row.salesPersonName, row.crmNumber, row.approvalRequestDate, row.OEM, row.opportunityName, 
//             row.transactionCurrency, row.secondaryTransactionCurrency, row.secondaryOptions, row.vendorPaymentTerms, row.vendorBillingCycle,
//             row.customerPaymentTerms, row.dealType, row.HitachiRoleInThisDeal, row.materialDeliveryDate, row.ReasonForMarginLessThanSixPercent,
//             row.RebateAmountDetails, row.ConversionRate, row.ExpectedDateCustomerRecipt, row.ExpectedDateVendorPayment, row.expertAdviceCashflow,
//             row.expertAdviceMargin, row.functionalHead1Name, row.functionalHead2Name, row.functionalHead3Name, row.functionalHead4Name,
//             row.functionalHead5Name, row.functionalHead6Name, row.sendForAppvReqDate
//           ];
//         } else if (userRole === 'TEAM LEADER' || userRole === 'BRANCH HEAD' || userRole === 'REGION BUSINESS HEAD' || userRole === 'BUSINESS FINANCE' || userRole === 'EXPORT COMPLIANCE'
//              || userRole === 'CREDIT INSURANCE' || userRole === 'CFO' || userRole === 'CEO' || userRole === 'COO' || userRole === 'SVP-DIRECTOR'  || 
//              userRole === 'LEGAL HEAD'|| userRole === 'DYT-CFO' || userRole === 'FUNCTIONAL HEAD' || userRole === 'ADMIN' ) {
//           header = [
//             "Form Series", "Status", "Customer Name", "SalesPerson Name", "CRM Number", "Approval Request Date", "OEM", "Opportunity Name",
//             "Transaction Currency", "Secondary Transaction Currency", "Secondary Options", "Vendor Payment Terms", "Vendor Billing Cycle",
//             "customerPaymentTerms", "dealType", "HitachiRoleInThisDeal", "materialDeliveryDate", "ReasonForMarginLessThanSixPercent",
//             "Rebate Amount Details", "Conversion Rate", "Expected Date Customer Recipt", "Expected Date Vendor Payment", "Expert Advice Cashflow",
//             "expert Advice Margin", "Send For Appv Req Date",
//             "Team Leader Remarks", "Branch Head Remarks", "Regional Business Head Remarks", "Business Finance Remarks", "Export Compliance Remarks", 
//             "Credit Insurance Remarks", "CFO Remarks", "CEO Remarks", "COO Remarks", "SVP-Director Remarks","Legal Head Remarks","DYT-CFO Remarks",
//             "Functional Head-1 Remarks", "Functional Head-2 Remarks", "Functional Head-3 Remarks", "Functional Head-4 Remarks", "Functional Head-5 Remarks", "Functional Head-6 Remarks" 
//           ];
      
//           rowMapper = (row) => [
//             row.formSeries, row.status, row.customerName, row.salesPersonName, row.crmNumber, row.approvalRequestDate, row.OEM, row.opportunityName, 
//             row.transactionCurrency, row.secondaryTransactionCurrency, row.secondaryOptions, row.vendorPaymentTerms, row.vendorBillingCycle,
//             row.customerPaymentTerms, row.dealType, row.HitachiRoleInThisDeal, row.materialDeliveryDate, row.ReasonForMarginLessThanSixPercent,
//             row.RebateAmountDetails, row.ConversionRate, row.ExpectedDateCustomerRecipt, row.ExpectedDateVendorPayment, row.expertAdviceCashflow,
//             row.expertAdviceMargin,  row.sendForAppvReqDate,
//             row.approval.appvTeamLeaderMessage, row.approval.appvBranchHeadMessage, row.approval.appvRegionBusinessHeadMessage, row.approval.appvBusinessFinanceMessage, row.approval.appvExportComplianceMessage, 
//             row.approval.appvCreditInsuranceMessage, row.approval.appvCFOMessage, row.approval.appvCEOMessage, row.approval.appvCOOMessage, row.approval.appvSVPDirectorMessage,
//             row.approval.appvFunctionalHeadMessage, row.approval.appvFunctionalHead2Message, row.approval.appvFunctionalHead3Message, row.approval.appvFunctionalHead4Message,
//             row.approval.appvFunctionalHead5Message, row.approval.appvFunctionalHead6Message
//           ];
//         } else {
//           alert("Export not allowed for this role.");
//           return;
//         }
      
//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet('Data');
      
//         worksheet.addRow(header);
      
//         const headerRow = worksheet.getRow(1);
//         headerRow.font = { bold: true, color: { argb: 'FFFFFF' } };
//         headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '808080' } };
//         headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
      
//         // Add rows
//         excelData.forEach(row => {
//           worksheet.addRow(rowMapper(row));
//         });
      
//         // Adjust column widths
//         header.forEach((column, index) => {
//           const maxLength = Math.max(column.length, ...excelData.map(row => String(rowMapper(row)[index] || '').length));
//           worksheet.getColumn(index + 1).width = maxLength + 2;
//         });
      
//         // Apply borders
//         for (let row = 1; row <= worksheet.rowCount; row++) {
//           for (let col = 1; col <= header.length; col++) {
//             const cell = worksheet.getCell(row, col);
//             cell.border = {
//               top: { style: 'thin', color: { argb: '000000' } },
//               left: { style: 'thin', color: { argb: '000000' } },
//               bottom: { style: 'thin', color: { argb: '000000' } },
//               right: { style: 'thin', color: { argb: '000000' } }
//             };
//           }
//         }
      
//         // Save file
//         workbook.xlsx.writeBuffer().then(buffer => {
//           const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//           FileSaver.saveAs(data, `${userName}_EntCostSheet_${getCurrentFormattedDate()}.xlsx`);
//         });
//       };

//     if (error) return <h1>Error: {error.message}</h1>;

//   return (
//      <>
//                  <Navbar />
//                  {/* <h1 className='headerRibbon'>Preloading Logs</h1> */}
     
//               <style>
//              {`
//                /* TR styling */
//                .expandable-row {
//                  transition: background-color 0.3s ease;
//                }
     
//                .expandable-row:hover {
//                  background-color: #f9f9f9;
//                }
     
//                /* TD styling */
//                .expandable-cell {
//                  padding: 0;
//                  margin: 0;
//                  border: none;
//                }
     
//                /* Inner wrapper for animation */
//                .cell-wrapper {
//                  max-height: 30px;
//                  overflow: hidden;
//                  transition: max-height 0.4s ease;
//                  padding: 10px;
//                }
     
//                .expandable-row:hover .cell-wrapper {
//                  max-height: 500px;
//                }
//              `}
//            </style>
     
//                  <MDBContainer className="pt-5 pb-4">
//                      <Row className="justify-content-between" md="12" style={{ display: "flex", border: "5px solid lightgrey", borderRadius: "20px" }}>
//                          {/* <Col md="auto">
//                              <img src={logo} className="w-100 shadow-4" style={{ maxWidth: '150px', height: 'auto' }} alt="login_banner_image" />
//                          </Col>
//                          <Col md="auto">
//                              <Button variant="success" onClick={() => { navigate('/CrmDetails'); }}>CRM DETAILS</Button>
//                          </Col> */}
//                          {/* {(sessionStorage.getItem('role') === 'SALES') && ( */}
//                          <Col md="8">
//                              <div style={{ padding: '20px' }}>
//                                  {/* Search Section */}
//                                  <Form className="d-flex gap-3">
//                                      <Form.Group controlId="searchKey">
//                                          {/* <Form.Label>Search Field</Form.Label> */}
//                                          <Form.Control
//                                              as="select"
//                                              value={searchKey}
//                                              onChange={(e) => setSearchKey(e.target.value)}
//                                          >
//                                              <option value="">-- Select Field --</option>
//                                              <option value="formSeries">Form Series</option>
//                                              <option value="crmNumber">CRM Number</option>
//                                              <option value="status">Final Status</option>
//                                              <option value="salesPersonName">Sales Person</option>
//                                              <option value="customerName">Customer Name</option>
//                                              {/* <option value="userId">Created By</option> */}
//                                              {/* Add more keys as needed */}
//                                          </Form.Control>
//                                      </Form.Group>
     
//                                      <Form.Group controlId="searchValue">
//                                          {/* <Form.Label>Search Value</Form.Label> */}
//                                          <Form.Control
//                                              type="text"
//                                              placeholder="Enter search value"
//                                              value={searchValue}
//                                              onChange={(e) => setSearchValue(e.target.value)}
//                                          />
//                                      </Form.Group>
//                                  </Form>
//                              </div>
//                          </Col>
//                          {(sessionStorage.getItem('role') === 'SALES' || sessionStorage.getItem('role') === 'TEAM LEADER' || sessionStorage.getItem('role') === 'ADMIN') && (
//                              <Col md="2">
//                                  <div style={{ padding: '20px' }}>
//                                      <Button variant="success" onClick={openNewForm}>New +</Button>
//                                  </div>
//                              </Col>
//                          )}
//                          <Col md="2">
//                              <div style={{ padding: '20px' }}>
//                                  <Button variant="outline-secondary" onClick={exportExcel}>EXPORT  <MDBIcon fas icon="fas fa-download" size='lg' /></Button>
//                              </div>
//                          </Col>
//                      </Row>
//                  </MDBContainer>
//                  <MDBContainer fluid style={{ justifyItems: 'center' }}>
//                      {/* <MDBContainer fluid className='vh-90' style={{ backgroundColor: "#E0E0E0" }}> */}
//                      <div style={styles.tableWrapper}>
//                          <MDBTable align='middle' bordered hover>
//                              <MDBTableHead className='table-dark sticky-header'>
//                                  <tr>
//                                      {/* <th scope='col' ></th> */}
//                                      <th scope='col' >Form Id</th>
//                                      <th scope='col' >CRM Number</th>
//                                      <th scope='col' >Customer Name</th>
//                                      <th scope='col' >Saleperson Id</th>
//                                      <th scope='col' >Salesperson Name</th>
//                                      <th scope='col' >Opportunity Name</th>
//                                      <th scope='col' >Opportunity Category</th>
//                                      <th scope='col' >Selling Value</th>
//                                      <th scope='col' >Created ID</th>
//                                      <th scope='col' >Creation Date</th>
//                                      <th scope='col' >Team Leader Status</th>
//                                      <th scope='col' >Branch Head Status</th>
//                                      <th scope='col' >Region Business Head Status</th>
//                                      <th scope='col' >Functional Head Status</th>
//                                      <th scope='col' >Business Finance Status</th>
//                                      <th scope='col' >Export Compliance Status</th>
//                                      <th scope='col' >Credit Insurance Status</th>
//                                      <th scope='col' >CEO Status</th>
//                                      <th scope='col' >COO Status</th>
//                                      <th scope='col' >CFO Status</th>
//                                      <th scope='col' >SVP Director Status</th>
//                                      <th scope='col' >DYT CFO Status</th>
//                                      <th scope='col' >Legal Head Status</th>
//                                      <th scope='col' >Final Status</th>
     
//                                  </tr>
//                              </MDBTableHead>
//                              <MDBTableBody>
//                                  {/* {currentRows */}
//                                  {[...currentRows]
//                                  .sort((a, b) => a.id - b.id)
//                                  .map((row, index) => (
//                                      <tr key={index} onDoubleClick={() => handleAction(row.formSeries)} className="expandable-row" >
//                                          {/* <th scope='row'></th> */}
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0 cell-wrapper'>{row.formSeries}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0 cell-wrapper'>{row.crmNumber}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0 cell-wrapper'>{row.customerName}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.salesPersonID}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.salesPersonName}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.opportunityName}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.OEM}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.sellingValueTotal}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.userId}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              <p className='text-muted mb-0  cell-wrapper'>{row.recordCreatedAt}</p>
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvTeamLeaderStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvTeamLeaderMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvTeamLeaderStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvTeamLeaderStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvBranchHeadStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvBranchHeadMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvBranchHeadStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvBranchHeadStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvRegionBusinessHeadMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvRegionBusinessHeadStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvFunctionalHeadMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvFunctionalHeadStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvBusinessFinanceStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvBusinessFinanceMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvBusinessFinanceStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvBusinessFinanceStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvExportComplianceStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvExportComplianceMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvExportComplianceStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvExportComplianceStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvCreditInsuranceStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCreditInsuranceMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCreditInsuranceStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvCreditInsuranceStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvCEOStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCEOMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCEOStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvCEOStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvCOOStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCOOMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCOOStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvCOOStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvCFOStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvCFOMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvCFOStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvCFOStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvSVPDirectorStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvSVPDirectorMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvSVPDirectorStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* ) : (
//                                                  <p className='text-muted mb-0  cell-wrapper'>{row.appvSVPDirectorStatus}</p>
//                                              )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvDytCFOMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvDytCFOStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                              {/* {row.appvRegionBusinessHeadStatus === 'Rejected' ? ( */}
//                                                  <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-bottom`}> {row.appvLegalHeadMessage || 'No message'} </Tooltip>}>
//                                                      <p className='text-muted mb-0  cell-wrapper' style={{ cursor: 'pointer' }}> {row.appvLegalHeadStatus} </p>
//                                                  </OverlayTrigger>
//                                              {/* // ) : (
//                                              //     <p className='text-muted mb-0  cell-wrapper'>{row.appvRegionBusinessHeadStatus}</p>
//                                              // )} */}
//                                          </td>
//                                          <td className="expandable-cell">
//                                          <MDBBadge 
//                                              color={
//                                                      row.status === 'Open' ? 'primary' :
//                                                      row.status === 'Sent for Approval' ? 'warning' :
//                                                      row.status === 'Partial Approval' ? 'success' :
//                                                      row.status === 'Approved' ? 'success' :
//                                                      row.status === 'PO Received' ? 'success' :
//                                                      row.status === 'Rejected' ? 'danger' :
//                                                      row.status === 'Partial Rejected' ? 'danger' :
//                                                      row.status === 'Closed' ? 'secondary' :
//                                                      null
//                                                  }pill> {row.status}
//                                          </MDBBadge>
//                                          </td>
//                                      </tr>
//                                  ))}
//                              </MDBTableBody>
//                          </MDBTable>
//                      </div>
     
//                      {/* Pagination Controls */}
//                      {/* <div style={styles.pagination}>
//                          <button
//                              style={styles.pageButton}
//                              disabled={currentPage === 1}
//                              onClick={() => handlePageChange(currentPage - 1)}
//                          >
//                              Previous
//                          </button>
//                          {[...Array(totalPages).keys()].map((number) => (
//                              <button
//                                  key={number}
//                                  style={{ ...styles.pageButton, ...(number + 1 === currentPage ? styles.activePageButton : {}) }}
//                                  onClick={() => handlePageChange(number + 1)}
//                              >
//                                  {number + 1}
//                              </button>
//                          ))}
//                          <button
//                              style={styles.pageButton}
//                              disabled={currentPage === totalPages}
//                              onClick={() => handlePageChange(currentPage + 1)}
//                          >
//                              Next
//                          </button>
//                      </div> */}
     
//                       <div style={styles.pagination}>
//                  <button
//                      style={styles.pageButton}
//                      disabled={currentPage === 1}
//                      onClick={() => handlePageChange(currentPage - 1)}
//                  >
//                      Previous
//                  </button>
     
//                  {startPage > 1 && (
//                      <>
//                          <button style={styles.pageButton} onClick={() => handlePageChange(1)}>1</button>
//                          <span style={styles.ellipsis}>...</span>
//                      </>
//                  )}
     
//                  {[...Array(endPage - startPage + 1).keys()].map((index) => {
//                      const pageNum = startPage + index;
//                      return (
//                          <button
//                              key={pageNum}
//                              style={{
//                                  ...styles.pageButton,
//                                  ...(pageNum === currentPage ? styles.activePageButton : {}),
//                              }}
//                              onClick={() => handlePageChange(pageNum)}
//                          >
//                              {pageNum}
//                          </button>
//                      );
//                  })}
     
//                  {endPage < totalPages && (
//                      <>
//                          <span style={styles.ellipsis}>...</span>
//                          <button style={styles.pageButton} onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
//                      </>
//                  )}
     
//                  <button
//                      style={styles.pageButton}
//                      disabled={currentPage === totalPages}
//                      onClick={() => handlePageChange(currentPage + 1)}
//                  >
//                      Next
//                  </button>
//              </div>
     
//                  </MDBContainer>
//              </>
//   )
// }

// // Inline CSS for the component
// const styles = {
//         tableWrapper: {
//             maxWidth: '95%',
//             overflowX: 'auto', // Enable horizontal scrolling
//             overflowY: 'auto', // Enable vertical scrolling
//             maxHeight: '450px', // Adjust the height to fit your needs
//             marginBottom: '10px',
//         },
//         pagination: {
//             display: 'flex',
//             justifyContent: 'center',
//             gap: '5px',
//             flexWrap: 'wrap',
//             marginTop: '1rem',
//         },
//         pageButton: {
//             backgroundColor: '#007bff',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             padding: '5px 10px',
//             cursor: 'pointer',
//             outline: 'none',
//         },
//         activePageButton: {
//             backgroundColor: '#0056b3',
//         },
//         ellipsis: {
//             padding: '5px 10px',
//             color: '#555',
//         },
            
//     };

// // CSS styles
// const stickyHeaderStyles = `
// .sticky-header th {
//     position: sticky;
//     top: 0;
//     z-index: 10; // Ensures the header is on top
//     background-color: #343a40; // Match the table header color
//     color: white; // Text color for header
// }
// `;

// // Add the sticky header styles to the document head
// const styleSheet = document.createElement("style");
// styleSheet.type = "text/css";
// styleSheet.innerText = stickyHeaderStyles;
// document.head.appendChild(styleSheet);

// export default CostSheetEntLogs
